<template>
  <section
    class="ex-banner"
    :aria-label="t('exclusiveUnits.banner.title')"
  >
    <p class="title">{{ t('exclusiveUnits.banner.title') }}</p>
    <p class="body">{{ t('exclusiveUnits.banner.body') }}</p>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped lang="scss">
.ex-banner {
  background: #0d0f15;
  color: #fff;
  border-radius: 12px;
  padding: 16px 18px;
  margin: 0 0 12px;

  .title {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 4px;
    color: #f5b041;
  }

  .body {
    font-size: 14px;
    margin: 0;
    color: rgba(255, 255, 255, 0.86);
  }
}
</style>
